import './common/theme/main.scss';
import 'rc-drawer/assets/index.css';

import {Provider} from 'react-redux';
import {ToastContainer} from "react-toastify";
import {store} from 'application/store';
import Routes from "./Routes";
import {LoadingContainer, ModalContainer} from "./common/components";
import {UnSignedDocumentsProvider} from "application/use-sign-documents";
import {MaintenancePage} from './maintenance/maintenance';

function App() {
  return (
     // <MaintenancePage/>
    <Provider store={store}>
      <UnSignedDocumentsProvider>
        <Routes/>
      </UnSignedDocumentsProvider>

      <ToastContainer/>
      <ModalContainer/>
      <LoadingContainer/>
    </Provider>
  );
}

export default App;
